<script>
import Vue from 'vue'
import TextInput from "@/Shared/TextInput";
import TabLayout from "@/Pages/Settings/Shared/TabLayout";
import axios from "axios";
import { throttle } from "lodash/function";

export default Vue.extend({
    name: "AccountValidation",
    metaInfo: {title: Lang.get('employeedashboard::pages/settings/two-factor-authentication.title')},
    components: {
        TabLayout,
        TextInput,
    },
    props: {
        errors: Object,
        email: String,
    },
    data() {
        return {
            form: this.$inertia.form({
                token: null,
            }),
            resendToken: {
                isSuccessful: false,
                hasError: false,
            },
            resendTokenFn: throttle(() => this.handleResendToken(), 30000),
        }
    },
    computed: {
        canSubmit() {
            return this.form.token?.length >= 6 && !this.form.processing;
        },
    },
    methods: {
        submit() {
            this.form.post(
                this.route(
                    'nl.employeedashboard.settings.two-factor-authentication.regenerate-recovery-codes.verify.account.post',
                ),
            );
        },
        async handleResendToken() {
            this.resendToken.isSuccessful = false;
            this.resendToken.hasError = false;
            try {
                await axios.post(
                    this.route('nl.employeedashboard.settings.two-factor-authentication.regenerate-recovery-codes.verify-email.send-new-token'),
                );

                this.resendToken.isSuccessful = true;
            } catch (error) {
                this.resendToken.hasError = true;
            }
        },
    },
})
</script>

<template>
    <tab-layout
        :title="Lang.get('employeedashboard::pages/settings/two-factor-authentication.title')"
        :subtitle="Lang.get('employeedashboard::pages/settings/two-factor-authentication.subtitle')"
        tabName="twoFactorAuthentication"
        :hideMsg="true"
    >
        <h2 class="h4 font-poppins font-weight-light color-dark-blue">
            {{
                Lang.get('employeedashboard::pages/settings/two-factor-authentication.regenerate-recovery-codes.verify-email.heading')
            }}
        </h2>
        <p class="font-poppins font-weight-light color-dark-blue" v-html="
            Lang.get('employeedashboard::pages/settings/two-factor-authentication.regenerate-recovery-codes.verify-email.instructions', {email})
        "></p>

        <form @submit.prevent="submit()">
            <div class="row mb-4">
                <div class="form-group col-12 col-md-4">
                    <text-input
                        v-model="form.token"
                        :label="Lang.get('employeedashboard::pages/settings/two-factor-authentication.regenerate-recovery-codes.verify-email.token.label')"
                        :error="errors.token"
                    />
                </div>
            </div>

            <div class="d-block">
                <p class="font-poppins color-dark-blue">
                    <span>{{
                            Lang.get('employeedashboard::pages/settings/two-factor-authentication.regenerate-recovery-codes.verify-email.retry.prefix')
                        }}</span>
                    <a href="#" @click='resendTokenFn'>{{
                            Lang.get('employeedashboard::pages/settings/two-factor-authentication.regenerate-recovery-codes.verify-email.retry.link')
                        }}</a>
                </p>

                <div class="my-3 p-2 rounded alert-info" v-if="resendToken.isSuccessful">
                    {{
                        Lang.get('employeedashboard::pages/settings/two-factor-authentication.regenerate-recovery-codes.verify-email.retry.success')
                    }}
                </div>

                <div class="my-3 p-2 rounded alert-danger" v-if="resendToken.hasError">
                    {{
                        Lang.get('employeedashboard::pages/settings/two-factor-authentication.regenerate-recovery-codes.verify-email.retry.failure')
                    }}
                </div>
            </div>

            <div class="row">
                <div class="form-group col-12 col-md-4">
                    <button
                        type="submit"
                        :disabled="!canSubmit"
                        class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4">
                        {{
                            Lang.get('employeedashboard::pages/settings/two-factor-authentication.regenerate-recovery-codes.password.button')
                        }}
                    </button>
                </div>
            </div>
        </form>
    </tab-layout>
</template>
